// @ts-strict-ignore
import type { Workflow } from '../types';

export type WorkflowState = {
  application?: Workflow;
};

export const initialState: WorkflowState = {
  application: null,
};
